const Level = (r) =>
  require.ensure([], () => r(require('@/views/level/index.vue')), 'Level')

export default [
  {
    path: 'level',
    name: 'level',
    component: Level,
  },
]
